import React, {useState} from 'react';
import axios from 'axios';
import SignIn from "./SignIn";
import authApi from "../../utils/authApi";

const SignUp = () => {

    const [formSubmit, setFormSubmit] = useState(false);
    const [pseudo, setPseudo] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [controlPassword, setControlPassword] = useState("");

    const handleRegister = async (e) => {
        e.preventDefault();
        const pseudoError = document.querySelector(".pseudo.error");
        const emailError = document.querySelector(".email.error");
        const passwordError = document.querySelector(".password.error");
        const passwordConfirmError = document.querySelector(
            ".password-confirm.error");

        passwordConfirmError.innerHTML = "";

        if (password !== controlPassword) {
            if (password !== controlPassword)
                passwordConfirmError.innerHTML =
                    "Les mots de passe ne correspondent pas";
        } else {
            try {
                passwordConfirmError.innerHTML = "";
                await authApi.register(pseudo, email, password);
            } catch (err) {
                console.log(err);
            }
        }
    };

    return (
        <>
            {formSubmit ? (
                    <>
                        <SignIn/>
                        <span/>
                        <h4 className="success">
                            Enregistrement réussi, veuillez-vous connecter
                        </h4>
                    </>
                ) :
                (
                    <form method="" onSubmit={handleRegister} id="sign-up-form">
                        <h2 className="my-12 text-3xl text-center">Inscription</h2>
                        <label htmlFor="pseudo">Pseudo</label>
                        <input
                            type="text"
                            className="block border border-grey-light w-full p-3 rounded mb-4"
                            name="pseudo"
                            placeholder="Pseudo"
                            onChange={(e) => setPseudo(e.target.value)}
                            value={pseudo}/>
                        <div className="pseudo error text-red-600"></div>
                        <br/>
                        <label htmlFor="email">Email</label>
                        <br/>
                        <input
                            type="text"
                            className="block border border-grey-light w-full p-3 rounded mb-4"
                            name="email"
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}/>
                        <div className="email error text-red-600"></div>
                        <br/>
                        <label htmlFor="password">Mot de passe</label>
                        <br/>
                        <input
                            type="password"
                            className="block border border-grey-light w-full p-3 rounded mb-4"
                            name="password"
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}/>
                        <div className="password error text-red-600"></div>
                        <br/>
                        <label htmlFor="password-conf">Confirmer mot de passe</label>
                        <br/>
                        <input
                            type="password"
                            className="block border border-grey-light w-full p-3 rounded mb-4"
                            name="password-conf"
                            placeholder="Confirm Password"
                            onChange={(e) => setControlPassword(e.target.value)}
                            value={controlPassword}/>
                        <div className="password-confirm error"></div>
                        <br/>
                        <button
                            type="submit"
                            className="w-full text-center py-3 rounded bg-red-50 hover:bg-red-300 focus:outline-none my-1"
                        >M'inscrire
                        </button>

                        <div className="text-center text-sm text-grey-dark mt-4">
                            By signing up, you agree to the
                            <a className="no-underline border-b border-grey-dark text-grey-dark" href="#">
                                Terms of Service
                            </a> and
                            <a className="no-underline border-b border-grey-dark text-grey-dark" href="#">
                                Privacy Policy
                            </a>
                            <div className="text-grey-dark mt-6">
                                Already have an account?
                                <a className="no-underline border-b border-blue text-blue" href="../login/">
                                    Log in
                                </a>.
                            </div>
                        </div>
                    </form>)}</>
    );
};

export default SignUp;